import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import './Navbar.css';
import InputSerach from '../InputSerach/InputSearchs';
import Favoritos from '../Favoritos/Favoritos';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelope, faShare } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebookF, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Configuración de react-modal para accesibilidad
Modal.setAppElement('#root');

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [tienda, setTienda] = useState({});

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setTienda(data?.tienda?.reverse()[0] || {});
            })
            .catch(error => console.error('Error al cargar datos de tienda:', error));
    };

    const abrirMapa = () => {
        const direccion = encodeURIComponent(tienda.direccion || 'Argentina');
        window.open(`https://www.google.com/maps/search/?api=1&query=${direccion}`, '_blank');
    };

    const compartirPagina = () => {
        if (navigator.share) {
            navigator.share({
                title: tienda.nombre || 'Chenille Muebles',
                url: window.location.href,
            }).catch(err => console.log('Error al compartir:', err));
        } else {
            navigator.clipboard.writeText(window.location.href);
            alert('¡Enlace copiado al portapapeles!');
        }
    };

    return (
        <header>
            <nav>
                <Anchor to={`/`} className='logo'>
                    {tienda?.imagen1 ? (
                        <img src={tienda?.imagen1} alt="logo" />
                    ) : (
                        <h2>{tienda?.nombre || 'CHENILLE'}</h2>
                    )}
                </Anchor>

                <div className='deFLexNavs'>
                    <InputSerach />
                    <Favoritos />

                    {/* Botón de 3 líneas (Hamburguesa) */}
                    <div className={`nav_toggle ${isOpen ? "open" : ""}`} onClick={() => setIsOpen(!isOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                {/* MODAL DESPLEGABLE */}
                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNavCard"
                    overlayClassName="overlayCard"
                    closeTimeoutMS={200}
                >
                    <div className="cardProfileContainer">
                        
                        {/* PORTADA Y LOGO CIRCULAR */}
                        <div className="cardHeader">
                            <img src="/portada.jpg" alt="Portada" className="coverImg" />
                            <div className="avatarContainer">
                                <img src="/logo.png" alt="Logo Avatar" className="avatarImg" />
                            </div>
                        </div>

                        {/* DETALLES DE LA TIENDA */}
                        <div className="cardBody">
                            <h3 className="cardTitle">{tienda.nombre || 'Chenille Muebles'}</h3>
                            <p className="cardSubtitle">{tienda.eslogan || 'Chenille Muebles'}</p>

                            {/* DIRECCIÓN Y EMAIL */}
                            <div className="infoSection">
                                <div className="infoBox" onClick={abrirMapa}>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className="infoIcon" />
                                    <span>{tienda.direccion || 'Chenille Muebles'}</span>
                                </div>

                                <a href={`mailto:${tienda.email || 'contacto@chenille.com'}`} target="_blank" rel="noopener noreferrer" className="infoBox">
                                    <FontAwesomeIcon icon={faEnvelope} className="infoIcon" />
                                    <span>{tienda.email || 'Chenille Muebles'}</span>
                                </a>
                            </div>

                            {/* REDES SOCIALES */}
                            <div className="socialIcons">
                                <a href={tienda.instagram || '#'} target="_blank" rel="noopener noreferrer" className="socialCircle">
                                    <FontAwesomeIcon icon={faInstagram} />
                                </a>
                                <a href={`https://wa.me/${tienda.telefono || ''}`} target="_blank" rel="noopener noreferrer" className="socialCircle">
                                    <FontAwesomeIcon icon={faWhatsapp} />
                                </a>
                                <a href={tienda.facebook || '#'} target="_blank" rel="noopener noreferrer" className="socialCircle">
                                    <FontAwesomeIcon icon={faFacebookF} />
                                </a>
                            </div>

                            {/* BOTÓN DE COMPARTIR */}
                            <button className="btnShareCard" onClick={compartirPagina}>
                                Compartir en.. <FontAwesomeIcon icon={faShare} />
                            </button>
                        </div>

                    </div>
                </Modal>
            </nav>
        </header>
    );
}
